import React from "react";

const ArrowDownFilled = ({ width = 12 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 13 13">
    <path d="M6.5,0,13,13H0Z" transform="translate(13 13) rotate(180)" />
  </svg>
);

export default ArrowDownFilled;
